import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { clientIntlPolyfill } from 'dibs-buyer-layout/exports/clientIntlPolyfill';
import { initVisitorTracking } from 'dibs-buyer-layout/src/entries/index';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';
import { getItemId } from 'dibs-checkout/exports/getItemId';
import { store } from 'dibs-checkout/exports/rootReducer';
import { CheckoutServerVarsContextProvider } from 'dibs-checkout/exports/CheckoutServerVarsContext';
import { CheckoutRoot } from 'dibs-checkout/exports/CheckoutRoot';
import {
    setPrerenderedCheckoutRootState,
    PRE_RENDER_STATE_NOT_INITIALIZED,
} from 'dibs-checkout/exports/prerender/prerenderedCheckoutStore';

const locale = serverVars.get('locale');
const messages = serverVars.get('messages');
const isMobile = serverVars.get('settings.isMobile');

export async function renderCheckout(): Promise<void> {
    await clientIntlPolyfill();

    const itemId = getItemId();

    if (!itemId) {
        (window as Window).location = '/404';
        return;
    }

    const rootElement = document.getElementById('js-root');
    if (rootElement) {
        const root = createRoot(rootElement, { identifierPrefix: 'abc' });
        /**
         * PRE_RENDER_STATE_NOT_INITIALIZED means checkout hasn't been pre-rendered
         */
        setPrerenderedCheckoutRootState(PRE_RENDER_STATE_NOT_INITIALIZED);
        root.render(
            <IntlProvider locale={locale} messages={messages}>
                <CheckoutServerVarsContextProvider checkoutType="standalone" isMobile={isMobile}>
                    <Provider store={store}>
                        <CheckoutRoot itemId={itemId} />
                    </Provider>
                </CheckoutServerVarsContextProvider>
            </IntlProvider>
        );

        // normally done in dbl, but checkout doesn't use it
        initVisitorTracking();
        // https://1stdibs.atlassian.net/browse/FI-2098
        // TODO: remove this once the initial AA tests are complete
        ['AA-Test-1', 'AA-Test-2', 'AA-Test-3', 'AA-Test-4', 'AA-Test-5'].forEach(testName =>
            trackAbTestV2Variant(testName)
        );
    }
}
